var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.previewMode)?_c('a',{attrs:{"href":_vm.externalUrl,"alt":_vm.title,"target":"_blank"}},[_c('img',{attrs:{"src":require("@/assets/edit.svg"),"alt":""}}),_vm._v(" "),(_vm.title)?_c('span',[_vm._v(_vm._s(_vm.title))]):_vm._e()]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b9d7ba0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AdminEdit.vue
// module id = null
// module chunks = 